import { SendNpsSurveyResponseArgs } from 'types/api/arguments/send-nps-survey-response-args'

import { api } from './api'

export const sendNpsSurveyResponse = ({
  userId,
  score,
  comment,
  incomplete,
}: SendNpsSurveyResponseArgs) =>
  api.post(`/users/${userId}/nps`, {
    score,
    comment,
    incomplete,
  })
